/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { GridColumnMenuFilterCell as t } from "./GridColumnMenuFilterCell.mjs";
import { DropDownList as c } from "@progress/kendo-react-dropdowns";
const d = (r) => {
  const { firstFilterProps: l, hideSecondFilter: n, secondFilterProps: o, logicData: a, logicValue: i, onLogicChange: m } = r;
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(t, { ...l }), !n && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    c,
    {
      data: a,
      value: i,
      onChange: m,
      className: "k-filter-and",
      textField: "text"
    }
  ), /* @__PURE__ */ e.createElement(t, { ...o })));
};
export {
  d as GridColumnMenuFilterUI
};
